module.exports = __webpack_public_path__ + "videos/tiktok_desktop.bd26209.mp4";